import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneSharedListPayload {
    sharedListId: string
}

export interface IOneSharedListState {
    status: string
    data: null
    errors: any
}

const initialState: IOneSharedListState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneSharedList = createSlice({
    name: 'sharedList/one-shared-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneSharedListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneSharedListActions = oneSharedList.actions
export default oneSharedList.reducer
